module.exports = __webpack_public_path__ + "a26dc1b5b3c75b820f797a9545f0ec27.pdf";